<template>
  <div class="title">
    <h1>{{ formTitleText }}</h1>
    <p>{{ formSubtext }}</p>
  </div>
</template>

<script>
export default {
  name: 'FormTitle',
  props: ['formTitleText', 'formSubtext'],
};
</script>
<style scoped>
.admin-form .title {
  color: var(--colorSecondary);
  margin-bottom: 5rem;
}
.title h1 {
  font-family: "gilroy", "sans-serif";
  margin-bottom: 2rem;
  font-size: 2.5rem;
}
.title p {
  font-size: 1rem;
  color: #545F8A;
  font-family: 'montserrat';
  margin-bottom: 2rem;
}
</style>
